var HlpInstance = e.Hlp;
var TrackingInstance = e.Tracking;

var Affiliate = {

	submit: function(e) {
		e.preventDefault();

		var $this = $(this);
		var form = $this.closest('form');
		var data = form.serialize();
        var noticeClean = function(form) {
            $('.notice-text:not(.static)', form).remove();
            $('.notice-error', form).removeClass('notice-error');
            $('.notice', form).fadeOut();
        };

		$this.addClass('btn-loading');

		$.ajax({
			url: HlpInstance.getApi() + '/affiliate/form',
			type: 'POST',
			data: data,
			success: function(data) {
				$this.removeClass('btn-loading');
				$("textarea", form).val('');
				$("input", form).parent().addClass('notice-success');
				form.fadeOut();
				form.parent().find('.ok').hide().removeClass('hidden').fadeIn();
				form.parent().find('.generalerror').hide();
			},
            error : function(xhr) {
                //reset first
                noticeClean();
                $this.removeClass('btn-loading');

                var err = xhr.responseJSON.errors;
                var holder;
                var focusChanged = false;

                for (var key in err) {
                    holder = $('.notice[data-key="' + key + '"]', form);
                    for (var i in err[key]) {

                        //custom error for login advice
                        if (err[key][i] === '##customerexists##') {
                            $('.notice[data-error="email_exists"]', form).hide().removeClass('hidden').addClass('notice-error').fadeIn();
                        } else {
                            var html = $('<strong class="notice-text"><div class="error">' + err[key][i] + '</div></strong>');
                            holder.append(html).hide().removeClass('hidden').fadeIn();
                            if (focusChanged === false) {
                                holder.parent().addClass('notice-error').velocity('scroll', {
                                    duration: 500,
                                    offset: -90,
                                    easing: 'linear'
                                });
                                focusChanged = true;
                            } else {
                                holder.parent().addClass('notice-error');
                            }
                        }
                    }
                }

                TrackingInstance.track({ eventCategory: 'Customer', eventAction: 'Create', eventLabel: 'fail'});
            }
		});
	}
};

/* on document load */
$(document).ready(function () {
    $('#affiliate-form button').on('click', Affiliate.submit);
});
